"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EstimateStatus = void 0;
var EstimateStatus;
(function (EstimateStatus) {
    EstimateStatus["ProviderStarted"] = "PROVIDER_STARTED";
    EstimateStatus["SentForInternalReview"] = "SENT_FOR_INTERNAL_REVIEW";
    EstimateStatus["SentForExternalReview"] = "SENT_FOR_EXTERNAL_REVIEW";
    EstimateStatus["DeclinedInternal"] = "DECLINED_INTERNAL";
    EstimateStatus["DeclinedConsumer"] = "DECLINED_CONSUMER";
    EstimateStatus["DeclinedExternal"] = "DECLINED_EXTERNAL";
    EstimateStatus["SentToConsumer"] = "SENT_TO_CONSUMER";
    EstimateStatus["AcceptedConsumer"] = "ACCEPTED_CONSUMER";
    EstimateStatus["Expired"] = "EXPIRED";
    EstimateStatus["Cancelled"] = "CANCELLED";
    EstimateStatus["InternalModifiedSentToProForReview"] = "INTERNAL_MODIFIED_SENT_TO_PRO_FOR_REVIEW";
    EstimateStatus["InternalModifying"] = "INTERNAL_MODIFYING";
})(EstimateStatus = exports.EstimateStatus || (exports.EstimateStatus = {}));
